import { useQuery } from '@tanstack/react-query';
import type { Connection } from 'home-assistant-js-websocket';
import type { RegistryState } from '../registry/types';
import { createRegistryClient } from '../registry/client';

const REGISTRY_QUERY_KEY = ['ha', 'registry'] as const;

export function useHARegistryQuery(connection: Connection | null) {
  return useQuery<RegistryState>({
    queryKey: REGISTRY_QUERY_KEY,
    queryFn: async () => {
      if (!connection) throw new Error('No HA connection');
      const client = createRegistryClient(connection);
      return await client.loadAll();
    },
    enabled: !!connection,
    staleTime: 5 * 60 * 1000,
  });
}
